import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";

import { getAllEmployeesQueryOptions } from "@/config/queries/query-options";
import { useMemo } from "react";
import { DataTable } from "./_components/employees-table/data-table";
import { columns } from "./_components/employees-table/columns";
import { AddPermissionsModal } from "./_components/add-permissions/add-permissions-modal";
import { RemovePermissionsModal } from "./_components/remove-permissions/remove-permissions-modal";
import { QueryError } from "@/components/query-error";

const EmployeePermissions = () => {
  const user = Cookies.get("key") as string;

  const { data, isPending, isFetching, isError, error, refetch } = useQuery(
    getAllEmployeesQueryOptions(user)
  );

  const employeesData = useMemo(() => {
    if (isPending || isFetching) {
      return [];
    }

    if (data === undefined || data?.employees === undefined) {
      return [];
    }

    const result = data?.employees?.map((emp) => {
      return {
        id: emp?._id,
        name: emp?.name,
        email: emp?.email,
        phone: emp?.phone,
        blockedStatus: emp?.blocked ? "blocked" : "not-blocked",
        ...(emp?.permissions
          ? { permissions: emp?.permissions }
          : {
              permissions: {
                1: [],
                2: [],
                3: [],
              },
            }),
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Employee Permissions</h3>
      </div>

      {isPending ? (
        <div>Loading</div>
      ) : isError ? (
        <QueryError what="employees" error={error} onRetry={refetch} />
      ) : data?.employees?.length ? (
        <div className="mt-5">
          <DataTable data={employeesData} columns={columns} />
        </div>
      ) : (
        <div className="border h-20 flex items-center justify-center mt-5">
          No Employees Found
        </div>
      )}

      <AddPermissionsModal />

      <RemovePermissionsModal />
    </div>
  );
};

export default EmployeePermissions;
